export default __webpack_public_path__ + "064f01a54243516d1aa69b9dc88c6ed1.png";